import { RoleId } from 'types';

export const ROLES = '/api/v1/roles';
export const ROLE_DETAILS = (roleId: RoleId) => `${ROLES}/${roleId}`;
export const ROLE_TEMPLATES = `${ROLES}/templates`;
export const ROLE_SCHEMA = `${ROLES}/schema`;
